/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

const UtilsInstance = new Utils();

var currentSummaryIndex = 0;
// Summary indexes
var diagnosticPageIndex = 0;
var faultPageIndex = 0;
var duplicatedIpPageIndex = 0;
var duplicatedNamePageIndex = 0;
var avgPingExceededLimitPageIndex = 0;
var deltaErrPageIndex = 0;
var wrongMAUTypePageIndex = 0;
var excessKbpsPageIndex = 0;
var inactivePortPageIndex = 0;
var firmwareIncoherencePageIndex = 0;
var moduleIncoherencePageIndex = 0;
var duplexMismatchPageIndex = 0;
var delayExceededPageIndex = 0;
var intermittentFailurePageIndex = 0;
var lostIpPageIndex = 0;
var disclaimerPageIndex = 0;

export class TsExpertReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),

      // Summary
      firstDiagnosticPage: -1,
      firstfaultPage: -1,
      firstDuplicatedIpPage: -1,
      firstDuplicatedNamePage: -1,
      firstAvgPingExceededLimitPage: -1,
      firstDeltaErrPage: -1,
      firstWrongMAUTypePage: -1,
      firstExcessKbpsPage: -1,
      firstInactivePortPage: -1,
      firstFirmwareIncoherencePage: -1,
      firstModuleIncoherencePage: -1,
      firstDuplexMismatchPage: -1,
      firstDelayExceededPage: -1,
      firstIntermittentFailurePage: -1,
      firstLostIpPage: -1,
      // Summary numbering control
      isFirstDiagnosticPage: true,
      isFirstfaultPage: true,
      isFirstDuplicatedIpPage: true,
      isFirstDuplicatedNamePage: true,
      isFirstAvgPingExceededLimitPage: true,
      isFirstDeltaErrPage: true,
      isFirstWrongMAUTypePage: true,
      isFirstExcessKbpsPage: true,
      isFirstInactivePortPage: true,
      isFirstFirmwareIncoherencePage: true,
      isFirstModuleIncoherencePage: true,
      isFirstDuplexMismatchPage: true,
      isFirstDelayExceededPage: true,
      isFirstIntermittentFailurePage: true,
      isFirstLostIpPage: true,
      // The report itself
      doc: ""
    };

  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  formatTime = (problem) => {
    if (problem.ntp !== null && problem.ntp === true) {
      let parsedMillis = Date.parse(problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problem.time !== undefined && problem.time !== null) {
      const eventTimeInMillis = problem.time * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.NO_ANSWER;
    }
  }

  /*
    The measurement time that is retrieved from the database comes as a string.
    We had a problem that the time that was being retrieved was not correct. 
    The workarround we found for this was to remove the last two characters of 
    the string and it miraculously it was in the format we nedded 
  */
  formatUptimeStringToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined && uptimeInSeconds !== "None" && uptimeInSeconds !== "") {
      let uptimeSubstring = uptimeInSeconds.substring(0, uptimeInSeconds.length - 2);
      let uptimeSubstringNumber = parseInt(uptimeSubstring);
      const uptimeInMillis = uptimeSubstringNumber * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
    else if (uptimeInSeconds === "None" || uptimeInSeconds === "") {
      return Strings.NO_ANSWER;
    }
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + "h");
    if (nd > 0) out.push(nd + "m");
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  parseFloatTo2DecimalPlaces = (floatInput) => {
    // If the floatInput is not 'None' return the number trimmed to 2 decimal places
    if (floatInput !== Constants.NONE) {
      return parseFloat(floatInput).toFixed(2);
    }
    else {
      return floatInput;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.TS_EXPERT_REPORT_EXPORT_NAME}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateNow()}, ${Strings.PAGE} ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "diagnostic" && this.state.isFirstDiagnosticPage) {
      this.setState({
        firstDiagnosticPage: pageNumber + 1,
        isFirstDiagnosticPage: false
      });
    }
    else if (reportPart === "fault" && this.state.isFirstfaultPage) {
      this.setState({
        firstfaultPage: pageNumber + 1,
        isFirstfaultPage: false
      });
    }
    else if (reportPart === "duplicatedIp" && this.state.isFirstDuplicatedIpPage) {
      this.setState({
        firstDuplicatedIpPage: pageNumber + 1,
        isFirstDuplicatedIpPage: false
      });
    }
    else if (reportPart === "duplicatedName" && this.state.isFirstDuplicatedNamePage) {
      this.setState({
        firstDuplicatedNamePage: pageNumber + 1,
        isFirstDuplicatedNamePage: false
      });
    }
    else if (reportPart === "avgPingExceededLimit" && this.state.isFirstAvgPingExceededLimitPage) {
      this.setState({
        firstAvgPingExceededLimitPage: pageNumber + 1,
        isFirstAvgPingExceededLimitPage: false
      });
    }
    else if (reportPart === "deltaErr" && this.state.isFirstDeltaErrPage) {
      this.setState({
        firstDeltaErrPage: pageNumber + 1,
        isFirstDeltaErrPage: false
      });
    }
    else if (reportPart === "wrongMAUType" && this.state.isFirstWrongMAUTypePage) {
      this.setState({
        firstWrongMAUTypePage: pageNumber + 1,
        isFirstWrongMAUTypePage: false
      });
    }
    else if (reportPart === "excessKbps" && this.state.isFirstExcessKbpsPage) {
      this.setState({
        firstExcessKbpsPage: pageNumber + 1,
        isFirstExcessKbpsPage: false
      });
    }
    else if (reportPart === "inactivePort" && this.state.isFirstInactivePortPage) {
      this.setState({
        firstInactivePortPage: pageNumber + 1,
        isFirstInactivePortPage: false
      });
    }
    else if (reportPart === "firmwareIncoherence" && this.state.isFirstFirmwareIncoherencePage) {
      this.setState({
        firstFirmwareIncoherencePage: pageNumber + 1,
        isFirstFirmwareIncoherencePage: false
      });
    }
    else if (reportPart === "moduleIncoherence" && this.state.isFirstModuleIncoherencePage) {
      this.setState({
        firstModuleIncoherencePage: pageNumber + 1,
        isFirstModuleIncoherencePage: false
      });
    }
    else if (reportPart === "duplexMismatch" && this.state.isFirstDuplexMismatchPage) {
      this.setState({
        firstDuplexMismatchPage: pageNumber + 1,
        isFirstDuplexMismatchPage: false
      });
    }
    else if (reportPart === "lineDelayExceededLimit" && this.state.isFirstDelayExceededPage) {
      this.setState({
        firstDelayExceededPage: pageNumber + 1,
        isFirstDelayExceededPage: false
      });
    }
    else if (reportPart === "intermittentFailure" && this.state.isFirstIntermittentFailurePage) {
      this.setState({
        firstIntermittentFailurePage: pageNumber + 1,
        isFirstIntermittentFailurePage: false
      });
    }
    else if (reportPart === "lostIp" && this.state.isFirstLostIpPage) {
      this.setState({
        firstLostIpPage: pageNumber + 1,
        isFirstLostIpPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.TS_EXPERT_REPORT_EXPORT_NAME}>
      {this.createIntroPage()}
      {this.createSummaryPage()}
      {this.createDiagnosticPages()}
      {this.createFaultsPages()}
      {this.createDuplicateIPPages()}
      {this.createDuplicateNamePages()}
      {this.createAvgPingExceededPages()}
      {this.createDeltaErrorsPages()}
      {this.createPortNotInFullDuplexPages()}
      {this.createExcessKbpsPages()}
      {this.createInactivePortPages()}
      {this.createFirmwareIncoherencePages()}
      {this.createModuleIncoherencePages()}
      {this.createDuplexMismatchPages()}
      {this.createDelayExceededPages()}
      {this.createIntermittentFailurePages()}
      {this.createLostIpPages()}
      {this.createDisclaimerPage()}
    </Document>;

    return doc;
  }

  createIntroPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "28vh" }} />

        <View style={reusableStyles.mainTitleUpperLine} />

        <Text style={reusableStyles.mainTitle}>
          {Strings.TS_EXPERT + ":"}
        </Text>

        <Text style={reusableStyles.mainTitle2}>
          {Strings.ACTIONS_LIST}
        </Text>

        <View style={reusableStyles.mainTitleBottomLine} />

        {this.getPageFooter()}
      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        {this.getSummaryItem(Constants.DIAGNOSTIC_ERROR_TYPE)}
        {this.getSummaryItem(Constants.FAULT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.DUPLICATE_IP_ERROR_TYPE)}
        {this.getSummaryItem(Constants.DUPLICATE_NAME_ERROR_TYPE)}
        {this.getSummaryItem(Constants.PING_ERROR_TYPE)}
        {this.getSummaryItem(Constants.DELTA_ERROR_TYPE)}
        {this.getSummaryItem(Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE)}
        {this.getSummaryItem(Constants.TRAFFIC_EXCESS_ERROR_TYPE)}
        {this.getSummaryItem(Constants.INACTIVE_PORT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.HW_FW_ERROR_TYPE)}
        {this.getSummaryItem(Constants.MODULE_INCOHERENCE_ERROR_TYPE)}
        {this.getSummaryItem(Constants.DUPLEX_MISMATCH_ERROR_TYPE)}
        {this.getSummaryItem(Constants.DELAY_ERROR_TYPE)}
        {this.getSummaryItem(Constants.INTERMITENT_FAILURE_ERROR_TYPE)}
        {this.getSummaryItem(Constants.LOST_IP_ERROR_TYPE)}
        {this.getSummaryItem("disclaimer")}

        {this.getPageFooter()}

      </Page>
    );
  }

  getSummaryItem = (type) => {
    if (type === Constants.DIAGNOSTIC_ERROR_TYPE && this.props.diagnostic.length > 0) {
      currentSummaryIndex++;
      diagnosticPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {diagnosticPageIndex}. {Strings.DEVICE_WITH_DIAGNOSTIC} {Strings.DEVICE_WITH_DIAGNOSTIC_DOTS} {this.state.firstDiagnosticPage}
        </Text>
      );
    }
    else if (type === Constants.FAULT_ERROR_TYPE && this.props.fault.length > 0) {
      currentSummaryIndex++;
      faultPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {faultPageIndex}. {Strings.DEVICE_WITH_FAULT} {Strings.DEVICE_WITH_FAULT_DOTS} {this.state.firstfaultPage}
        </Text>
      );
    }
    else if (type === Constants.DUPLICATE_IP_ERROR_TYPE && this.props.duplicatedIp.length > 0) {
      currentSummaryIndex++;
      duplicatedIpPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {duplicatedIpPageIndex}. {Strings.DEVICES_WITH_DUPLICATE_IP} {Strings.DEVICES_WITH_DUPLICATE_IP_DOTS} {this.state.firstDuplicatedIpPage}
        </Text>
      );
    }
    else if (type === Constants.DUPLICATE_NAME_ERROR_TYPE && this.props.duplicatedName.length > 0) {
      currentSummaryIndex++;
      duplicatedNamePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {duplicatedNamePageIndex}. {Strings.DEVICES_WITH_DUPLICATE_NAME} {Strings.DEVICES_WITH_DUPLICATE_NAME_DOTS} {this.state.firstDuplicatedNamePage}
        </Text>
      );
    }
    else if (type === Constants.PING_ERROR_TYPE && this.props.avgPingExceededLimit.length > 0) {
      currentSummaryIndex++;
      avgPingExceededLimitPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {avgPingExceededLimitPageIndex}. {Strings.PING_LIMIT_EXCEEDED} {Strings.PING_LIMIT_EXCEEDED_DOTS} {this.state.firstAvgPingExceededLimitPage}
        </Text>
      );
    }
    else if (type === Constants.DELTA_ERROR_TYPE && this.props.deltaErr.length > 0) {
      currentSummaryIndex++;
      deltaErrPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {deltaErrPageIndex}. {Strings.DELTA_ERROR_ALARM} {Strings.DELTA_ERROR_ALARM_DOTS} {this.state.firstDeltaErrPage}
        </Text>
      );
    }
    else if (type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE && this.props.wrongMAUType.length > 0) {
      currentSummaryIndex++;
      wrongMAUTypePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {wrongMAUTypePageIndex}. {Strings.PORT_NOT_IN_FULL_DUPLEX} {Strings.PORT_NOT_IN_FULL_DUPLEX_DOTS} {this.state.firstWrongMAUTypePage}
        </Text>
      );
    }
    else if (type === Constants.TRAFFIC_EXCESS_ERROR_TYPE && this.props.excessKbps.length > 0) {
      currentSummaryIndex++;
      excessKbpsPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {excessKbpsPageIndex}. {Strings.TRAFFIC_EXCESS} {Strings.TRAFFIC_EXCESS_DOTS} {this.state.firstExcessKbpsPage}
        </Text>
      );
    }
    else if (type === Constants.INACTIVE_PORT_ERROR_TYPE && this.props.inactivePort.length > 0) {
      currentSummaryIndex++;
      inactivePortPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {inactivePortPageIndex}. {Strings.INACTIVE_PORT} {Strings.INACTIVE_PORT_DOTS} {this.state.firstInactivePortPage}
        </Text>
      );
    }
    else if (type === Constants.HW_FW_ERROR_TYPE && this.props.firmwareIncoherence.length > 0) {
      currentSummaryIndex++;
      firmwareIncoherencePageIndex = currentSummaryIndex;
      if (firmwareIncoherencePageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {firmwareIncoherencePageIndex}. {Strings.HW_FW} {Strings.HW_FW_DOTS} {this.state.firstFirmwareIncoherencePage}
          </Text>
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {firmwareIncoherencePageIndex}. {Strings.HW_FW} {Strings.HW_FW_DOTS_2} {this.state.firstFirmwareIncoherencePage}
          </Text>
        );
      }
    }
    else if (type === Constants.MODULE_INCOHERENCE_ERROR_TYPE && this.props.moduleIncoherence.length > 0) {
      currentSummaryIndex++;
      moduleIncoherencePageIndex = currentSummaryIndex;
      if (moduleIncoherencePageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {moduleIncoherencePageIndex}. {Strings.MODULE_INCOHERENCE} {Strings.MODULE_INCOHERENCE_DOTS} {this.state.firstModuleIncoherencePage}
          </Text>
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {moduleIncoherencePageIndex}. {Strings.MODULE_INCOHERENCE} {Strings.MODULE_INCOHERENCE_DOTS_2} {this.state.firstModuleIncoherencePage}
          </Text>
        );
      }
    }
    else if (type === Constants.DUPLEX_MISMATCH_ERROR_TYPE && this.props.duplexMismatch.length > 0) {
      currentSummaryIndex++;
      duplexMismatchPageIndex = currentSummaryIndex;
      if (duplexMismatchPageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {duplexMismatchPageIndex}. {Strings.DUPLEX_MISMATCH} {Strings.DUPLEX_MISMATCH_DOTS} {this.state.firstDuplexMismatchPage}
          </Text>
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {duplexMismatchPageIndex}. {Strings.DUPLEX_MISMATCH} {Strings.DUPLEX_MISMATCH_DOTS_2} {this.state.firstDuplexMismatchPage}
          </Text>
        );
      }
    }
    else if (type === Constants.DELAY_ERROR_TYPE && this.props.lineDelayExceededLimit.length > 0) {
      currentSummaryIndex++;
      delayExceededPageIndex = currentSummaryIndex;
      if (delayExceededPageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {delayExceededPageIndex}. {Strings.DELAY_EXCEEDED} {Strings.DELAY_EXCEEDED_DOTS} {this.state.firstDelayExceededPage}
          </Text>
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {delayExceededPageIndex}. {Strings.DELAY_EXCEEDED} {Strings.DELAY_EXCEEDED_DOTS_2} {this.state.firstDelayExceededPage}
          </Text>
        );
      }
    }
    else if (type === Constants.INTERMITENT_FAILURE_ERROR_TYPE && this.props.intermittentFailure.length > 0) {
      currentSummaryIndex++;
      intermittentFailurePageIndex = currentSummaryIndex;
      if (intermittentFailurePageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {intermittentFailurePageIndex}. {Strings.DEVICE_WITH_INTERMITTENT_FAILURE} {Strings.DEVICE_WITH_INTERMITTENT_FAILURE_DOTS} {this.state.firstIntermittentFailurePage}
          </Text>
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} fixed>
            {intermittentFailurePageIndex}. {Strings.DEVICE_WITH_INTERMITTENT_FAILURE} {Strings.DEVICE_WITH_INTERMITTENT_FAILURE_DOTS_2} {this.state.firstIntermittentFailurePage}
          </Text>
        );
      }
    }
    else if (type === Constants.LOST_IP_ERROR_TYPE && this.props.lostIp.length > 0) {
      currentSummaryIndex++;
      lostIpPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {lostIpPageIndex}. {Strings.DEVICE_WITH_LOST_IP} {Strings.DEVICE_WITH_LOST_IP_DOTS} {this.state.firstLostIpPage}
        </Text>
      );
    }
    else if (type === "disclaimer") {
      currentSummaryIndex++;
      disclaimerPageIndex = currentSummaryIndex;
      if (disclaimerPageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_EXPERT_DOTS} ${totalPages}`
          )} fixed />
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_EXPERT_DOTS_2} ${totalPages}`
          )} fixed />
        );
      }

    }
  }

  resetSummaryIndexes = () => {
    currentSummaryIndex = 0;
    diagnosticPageIndex = 0;
    faultPageIndex = 0;
    duplicatedIpPageIndex = 0;
    duplicatedNamePageIndex = 0;
    avgPingExceededLimitPageIndex = 0;
    deltaErrPageIndex = 0;
    wrongMAUTypePageIndex = 0;
    excessKbpsPageIndex = 0;
    inactivePortPageIndex = 0;
    firmwareIncoherencePageIndex = 0;
    moduleIncoherencePageIndex = 0;
    duplexMismatchPageIndex = 0;
    delayExceededPageIndex = 0;
    intermittentFailurePageIndex = 0;
    lostIpPageIndex = 0;
    disclaimerPageIndex = 0;
  }

  // ----------------- DIAGNOSTICS -----------------
  createDiagnosticPages = () => {
    if (this.props.diagnostic.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={alarmStyles.page}>

          {this.getPageHeader()}

          <Text style={alarmStyles.pageTitle} fixed>{diagnosticPageIndex}{Strings.DIAGNOSTIC_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DIAGNOSTIC_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>{Strings.DIAGNOSTIC_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={alarmStyles.table}>
            {this.createDiagnosticsTableHeader()}
            {this.createDiagnosticsTable()}
          </View>

          {this.getPageFooter("diagnostic")}

        </Page>
      );
    }
  }

  createDiagnosticsTableHeader = () => {
    return (
      <View style={alarmStyles.tableRow} fixed>

        <View style={alarmStyles.horaryTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={alarmStyles.ipTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={alarmStyles.macTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={alarmStyles.productNameTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={alarmStyles.pingTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.ALARMS}</Text>
        </View>

        <View style={alarmStyles.solvedTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDiagnosticsTable = () => {
    return (
      this.props.diagnostic.map(problem => {
        return (
          <View style={alarmStyles.tableRow} key={problem._id} wrap={false}>

            <View style={alarmStyles.horaryTableCol}>
              <Text style={alarmStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={alarmStyles.ipTableCol}>
              <Text style={alarmStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={alarmStyles.macTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={alarmStyles.productNameTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.name, false)}</Text>
            </View>

            <View style={alarmStyles.pingNameTableCol}>
              <Text style={alarmStyles.tableCell}>{problem.total}</Text>
            </View>

            <View style={alarmStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- FAULTS -----------------
  createFaultsPages = () => {
    if (this.props.fault.length > 0) {

      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={alarmStyles.page}>

          {this.getPageHeader()}

          <Text style={alarmStyles.pageTitle} fixed>{faultPageIndex}{Strings.FAULT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.FAULT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_4}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_5}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_6}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={alarmStyles.table}>
            {this.createFaultsTableHeader()}
            {this.createFaultsTable()}
          </View>

          {this.getPageFooter("fault")}

        </Page>
      );
    }
  }

  createFaultsTableHeader = () => {
    return (
      <View style={alarmStyles.tableRow} fixed>

        <View style={alarmStyles.horaryTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={alarmStyles.ipTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={alarmStyles.macTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={alarmStyles.productNameTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={alarmStyles.pingTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.FAULTS}</Text>
        </View>

        <View style={alarmStyles.solvedTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createFaultsTable = () => {
    return (
      this.props.fault.map(problem => {
        return (
          <View style={alarmStyles.tableRow} key={problem._id} wrap={false}>

            <View style={alarmStyles.horaryTableCol}>
              <Text style={alarmStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={alarmStyles.ipTableCol}>
              <Text style={alarmStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={alarmStyles.macTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={alarmStyles.productNameTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.name, false)}</Text>
            </View>

            <View style={alarmStyles.pingNameTableCol}>
              <Text style={alarmStyles.tableCell}>{problem.total}</Text>
            </View>

            <View style={alarmStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- Duplicate IP -----------------
  createDuplicateIPPages = () => {
    if (this.props.duplicatedIp.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={duplicateIPStyles.page}>

          {this.getPageHeader()}
          <Text style={duplicateIPStyles.pageTitle} fixed>{duplicatedIpPageIndex}{Strings.DUPLICATE_IP_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DUPLICATE_IP_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />
          <Text style={reusableStyles.normalText}>{Strings.DUPLICATE_IP_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={duplicateIPStyles.table}>
            {this.createDuplicateIPTableHeader()}
            {this.createDuplicateIPTable()}
          </View>

          {this.getPageFooter("duplicatedIp")}

        </Page>
      );
    }
  }

  createDuplicateIPTableHeader = () => {
    return (
      <View style={duplicateIPStyles.tableRow} fixed>

        <View style={duplicateIPStyles.horaryTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={duplicateIPStyles.ipMacNameTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={duplicateIPStyles.ipMacNameTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.MACS}</Text>
        </View>

        <View style={duplicateIPStyles.checkedTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDuplicateIPTable = () => {
    return (
      this.props.duplicatedIp.map(problem => {
        return (
          <View style={duplicateIPStyles.tableRow} key={problem._id} wrap={false}>

            <View style={duplicateIPStyles.horaryTableCol}>
              <Text style={duplicateIPStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={duplicateIPStyles.ipMacNameTableCol}>
              <Text style={duplicateIPStyles.tableCell}>{problem.ip}</Text>
            </View>
            <View style={duplicateIPStyles.ipMacNameTableCol}>
              {
                problem.macs.map(mac => (
                  <Text style={duplicateIPStyles.tableCell} key={mac}>{UtilsInstance.treatUppercase(mac)}</Text>
                ))
              }
            </View>

            <View style={duplicateIPStyles.checkedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- Duplicate Name -----------------
  createDuplicateNamePages = () => {
    if (this.props.duplicatedName.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={duplicateNameStyles.page}>

          {this.getPageHeader()}
          <Text style={duplicateNameStyles.pageTitle} fixed>{duplicatedNamePageIndex}{Strings.DUPLICATE_NAME_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DUPLICATE_NAME_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />
          <Text style={reusableStyles.normalText}>{Strings.DUPLICATE_NAME_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={duplicateNameStyles.table}>
            {this.createDuplicateNameTableHeader()}
            {this.createDuplicateNameTable()}
          </View>

          {this.getPageFooter("duplicatedName")}

        </Page>
      );
    }
  }

  createDuplicateNameTableHeader = () => {
    return (
      <View style={duplicateNameStyles.tableRow} fixed>

        <View style={duplicateNameStyles.horaryTableColHeader}>
          <Text style={duplicateNameStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={duplicateNameStyles.nameTableColHeader}>
          <Text style={duplicateNameStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={duplicateNameStyles.ipMacTableColHeader}>
          <Text style={duplicateNameStyles.tableCellHeader}>{Strings.IPS}</Text>
        </View>

        <View style={duplicateNameStyles.ipMacTableColHeader}>
          <Text style={duplicateNameStyles.tableCellHeader}>{Strings.MACS}</Text>
        </View>

        <View style={duplicateNameStyles.checkedTableColHeader}>
          <Text style={duplicateNameStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDuplicateNameTable = () => {
    return (
      this.props.duplicatedName.map(problem => {
        return (
          <View style={duplicateNameStyles.tableRow} key={problem._id} wrap={false}>

            <View style={duplicateNameStyles.horaryTableCol}>
              <Text style={duplicateNameStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={duplicateNameStyles.nameTableCol}>
              <Text style={duplicateNameStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.name, false)}</Text>
            </View>

            <View style={duplicateNameStyles.ipMacTableCol}>
              {
                problem.ips.map(ip => (
                  <Text key={ip} style={duplicateNameStyles.tableCell}>{ip}</Text>
                ))
              }
            </View>

            <View style={duplicateNameStyles.ipMacTableCol}>
              {
                problem.macs.map(mac => (
                  <Text key={mac} style={duplicateNameStyles.tableCell}>{UtilsInstance.treatUppercase(mac)}</Text>
                ))
              }
            </View>

            <View style={duplicateNameStyles.checkedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- PING LIMIT -----------------
  createAvgPingExceededPages = () => {
    if (this.props.avgPingExceededLimit.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={avgPingExceededStyles.page}>

          {this.getPageHeader()}
          <Text style={avgPingExceededStyles.pageTitle} fixed>{avgPingExceededLimitPageIndex}{Strings.PING_LIMIT_EXCEEDED_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.PING_LIMIT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.boldText}>{Strings.PING_LIMIT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.PING_LIMIT_SUGGESTION_4}</Text>

          <Text style={reusableStyles.boldText}>{Strings.PING_LIMIT_SUGGESTION_5}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.PING_LIMIT_SUGGESTION_6}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.PING_LIMIT_SUGGESTION_7}</Text>

          <Text style={reusableStyles.boldText}>{Strings.PING_LIMIT_SUGGESTION_8}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.PING_LIMIT_SUGGESTION_9}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={avgPingExceededStyles.table}>
            {this.createAvgPingExceededTableHeader()}
            {this.createAvgPingExceededTable()}
          </View>

          {this.getPageFooter("avgPingExceededLimit")}

        </Page>
      );
    }
  }

  createAvgPingExceededTableHeader = () => {
    return (
      <View style={avgPingExceededStyles.tableRow} fixed>

        <View style={avgPingExceededStyles.horaryTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={avgPingExceededStyles.ipTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={avgPingExceededStyles.macTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={avgPingExceededStyles.productNameTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={avgPingExceededStyles.pingTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.REGISTERED_PING}</Text>
        </View>

        <View style={avgPingExceededStyles.solvedTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createAvgPingExceededTable = () => {
    return (
      this.props.avgPingExceededLimit.map(problem => {
        return (
          <View style={avgPingExceededStyles.tableRow} key={problem._id} wrap={false}>

            <View style={avgPingExceededStyles.horaryTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={avgPingExceededStyles.ipTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={avgPingExceededStyles.macTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={avgPingExceededStyles.productNameTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.product_name, false)}</Text>
            </View>

            <View style={avgPingExceededStyles.pingNameTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{problem.ping.toFixed(2)} ms</Text>
            </View>

            <View style={avgPingExceededStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- DELTA ERRORS -----------------
  createDeltaErrorsPages = () => {
    if (this.props.deltaErr.length > 0) {

      return (
        <Page
          size="A4"
          orientation="landscape"
          wrap={true}
          style={deltaErrorsStyles.page}>

          {this.getPageHeader()}
          <Text style={deltaErrorsStyles.pageTitle} fixed>{deltaErrPageIndex}{Strings.DELTA_ERROR_ALARM_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DELTA_ERRORS_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.boldText}>{Strings.DELTA_ERRORS_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.DELTA_ERRORS_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.DELTA_ERRORS_SUGGESTION_4}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.DELTA_ERRORS_SUGGESTION_5}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.DELTA_ERRORS_SUGGESTION_6}</Text>

          <Text style={reusableStyles.boldText}>{Strings.DELTA_ERRORS_SUGGESTION_7}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.DELTA_ERRORS_SUGGESTION_8}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.DELTA_ERRORS_SUGGESTION_9}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.DELTA_ERRORS_SUGGESTION_10}</Text>

          <View style={{ marginBottom: "12vh" }}></View>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DEVS_WITH_DELTA_ERRORS_EXPLANATION_1}</Text>
          <Text style={reusableStyles.lastInfoText}>{Strings.DEVS_WITH_DELTA_ERRORS_EXPLANATION_2}</Text>

          <View style={deltaErrorsStyles.table}>
            {this.createDeltaErrorsTableHeader()}
            {this.createDeltaErrorsTable()}
          </View>

          {this.getPageFooter("deltaErr")}

        </Page>
      );
    }
  }

  createDeltaErrorsTableHeader = () => {
    return (
      <View style={deltaErrorsStyles.tableRow} fixed>

        <View style={deltaErrorsStyles.ipTableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.ON_TIME}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.DUPLEX_MODE}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.LINE_DELAY_VALUE_1}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{`${Strings.INTERFACE_SPEED_1}\n${Strings.INTERFACE_SPEED_2}`}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.DELTA_ERRORS_SUGGESTION_2}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.DELTA_ERRORS_SUGGESTION_7}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.STATUS}</Text>
        </View>

        <View style={deltaErrorsStyles.tableColHeader}>
          <Text style={deltaErrorsStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDeltaErrorsTable = () => {
    return (
      this.props.deltaErr.map(device => {
        return (
          <View wrap={false} key={device.ip}>

            <View style={deltaErrorsStyles.tableRow} wrap={false}>

              <View style={deltaErrorsStyles.ipTableCol}>
                <Text style={deltaErrorsStyles.tableCell}>{device.ip}</Text>
              </View>

              <View style={deltaErrorsStyles.tableCol}>
                <Text style={deltaErrorsStyles.tableCell}>
                  {UtilsInstance.getDeviceName(device.name, Strings, UtilsInstance)}
                </Text>
              </View>

              <View style={deltaErrorsStyles.tableCol}>
                <Text style={deltaErrorsStyles.tableCell}>
                  {this.formatUptimeStringToRelativeTime(device.uptime)}
                </Text>
              </View>

              <View style={deltaErrorsStyles.whitespaceTableCol}>
                <Text style={deltaErrorsStyles.tableCell}></Text>
              </View>
            </View>

            {
              // eslint-disable-next-line
              device.ports.map(port => {
                if (port.hasErrorsIncrement) {
                  return (
                    <View style={deltaErrorsStyles.tableRow} key={port.name} wrap={false}>

                      <View style={deltaErrorsStyles.portNameTableCol}>
                        <Text style={deltaErrorsStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(port.name, false)}</Text>
                      </View>

                      {this.getMAUTypeCell(port.MAUType)}
                      {this.getLineDelayValueCell(port.lineDelayValue)}
                      {this.getSpeedCell(port.speed)}
                      {this.createErrorsTableCell(port.inputErrors, port.inputErrorsIncrement)}
                      {this.createErrorsTableCell(port.exitErrors, port.exitErrorsIncrement)}
                      {this.getLinkStateLinkCell(port.linkStateLink)}

                      <View style={deltaErrorsStyles.solvedTableCol}>
                        <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
                      </View>

                    </View>
                  );
                }
              })
            }
          </View >
        );

      })
    );
  }

  getMAUTypeCell = (MAUType) => {
    if (MAUType === null) {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else if (MAUType === "") {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else if (MAUType.toUpperCase() === Constants.UNKNOWN_UPPERCASE) {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{MAUType}</Text>
        </View>
      );
    }
  }

  getLineDelayValueCell = (lineDelayValue) => {
    if (lineDelayValue === null) {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else if (lineDelayValue === "") {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else if (lineDelayValue.toUpperCase() === "UNKNOWN") {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else {
      if (lineDelayValue.includes("Cable delay") || lineDelayValue.includes("Line delay")) {
        let value = Number(lineDelayValue.split(":")[1].replaceAll(" ", ""));
        if (value > 528) {
          return (
            <View style={deltaErrorsStyles.errorTableCol}>
              <Text style={deltaErrorsStyles.tableCell}>{lineDelayValue} ns</Text>
            </View>
          );
        }
        else {
          return (
            <View style={deltaErrorsStyles.tableCol}>
              <Text style={deltaErrorsStyles.tableCell}>{lineDelayValue} ns</Text>
            </View>
          );
        }
      }
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{lineDelayValue} ns</Text>
        </View>
      );
    }
  }

  getSpeedCell = (interface_speed) => {
    if (interface_speed !== "") {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{interface_speed} Mbps</Text>
        </View>
      );
    }
    else {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
  }

  createErrorsTableCell = (errors, increment) => {
    if (increment > 0) {
      return (
        <View style={deltaErrorsStyles.errorTableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{errors}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={deltaErrorsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{errors}</Text>
        </View>
      );
    }
  }

  getLinkStateLinkCell = (linkStateLink) => {
    if (linkStateLink === "up") {
      return (
        <View style={deltaErrorsStyles.activeTableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.ACTIVE}</Text>
        </View>
      );
    }
    else if (linkStateLink === "down") {
      return (
        <View style={deltaErrorsStyles.unknownTableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.INACTIVE}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={deltaErrorsStyles.unknownTableCol}>
          <Text style={deltaErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
  }

  // ----------------- NOT IN FULL DUPLEX -----------------
  createPortNotInFullDuplexPages = () => {
    if (this.props.wrongMAUType.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={portNotInFullDuplexStyles.page}>

          {this.getPageHeader()}
          <Text style={portNotInFullDuplexStyles.pageTitle} fixed>{wrongMAUTypePageIndex}{Strings.PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>• {Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={portNotInFullDuplexStyles.table}>
            {this.createPortNotInFullDuplexTableHeader()}
            {this.createPortNotInFullDuplexTable()}
          </View>

          {this.getPageFooter("wrongMAUType")}

        </Page>
      );
    }
  }

  createPortNotInFullDuplexTableHeader = () => {
    return (
      <View style={portNotInFullDuplexStyles.tableRow} fixed>

        <View style={portNotInFullDuplexStyles.horaryTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.ipTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.macTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.productNameTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.interfaceLabelTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.duplexModeTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>
            {Strings.DUPLEX_MODE_1}{"\n"}
            {Strings.DUPLEX_MODE_2}
          </Text>
        </View>

        <View style={portNotInFullDuplexStyles.solvedTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createPortNotInFullDuplexTable = () => {
    return (
      this.props.wrongMAUType.map(problem => {
        return (
          <View style={portNotInFullDuplexStyles.tableRow} key={problem._id} wrap={false}>

            <View style={portNotInFullDuplexStyles.horaryTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.ipTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.macTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.productNameTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.name, false)}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.interfaceLabelTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.portName, false)}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.duplexModeTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{problem.MAUType}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- EXCESS KBPS -----------------
  createExcessKbpsPages = () => {
    if (this.props.excessKbps.length > 0) {
      return (
        <Page
          size="A4"
          orientation="landscape"
          wrap={true}
          style={excessKbpsStyles.page}>

          {this.getPageHeader()}
          <Text style={excessKbpsStyles.pageTitle} fixed>{excessKbpsPageIndex}{Strings.TRAFFIC_EXCESS_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.TRAFFIC_EXCESS_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>{Strings.TRAFFIC_EXCESS_SUGGESTION_2}</Text>

          <Text style={reusableStyles.normalText}>• {Strings.TRAFFIC_EXCESS_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.TRAFFIC_EXCESS_SUGGESTION_4}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.TRAFFIC_EXCESS_SUGGESTION_5}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_1}</Text>
          <Text style={reusableStyles.lastInfoText}>{Strings.DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_2}</Text>

          <View style={excessKbpsStyles.table}>
            {this.createExcessKbpsTableHeader()}
            {this.createExcessKbpsTable()}
          </View>

          {this.getPageFooter("excessKbps")}

        </Page>
      );
    }
  }

  createExcessKbpsTableHeader = () => {
    return (
      <View style={excessKbpsStyles.tableRow} fixed>

        <View style={excessKbpsStyles.ipTableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.ON_TIME}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.DUPLEX_MODE}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.LINE_DELAY_VALUE_1}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{`${Strings.INTERFACE_SPEED_1}\n${Strings.INTERFACE_SPEED_2}`}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.INPUT_TRAFFIC_KBPS}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.OUTPUT_TRAFFIC_KBPS}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.STATUS}</Text>
        </View>

        <View style={excessKbpsStyles.tableColHeader}>
          <Text style={excessKbpsStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createExcessKbpsTable = () => {
    return (
      this.props.excessKbps.map(device => {
        return (
          <View wrap={false} key={device.ip}>

            <View style={excessKbpsStyles.tableRow} wrap={false}>

              <View style={excessKbpsStyles.ipTableCol}>
                <Text style={excessKbpsStyles.tableCell}>{device.ip}</Text>
              </View>

              <View style={excessKbpsStyles.tableCol}>
                <Text style={excessKbpsStyles.tableCell}>
                  {UtilsInstance.addWhitespaceToLongStrings(device.name, false)}
                </Text>
              </View>

              <View style={excessKbpsStyles.tableCol}>
                <Text style={excessKbpsStyles.tableCell}>
                  {this.formatUptimeStringToRelativeTime(device.uptime)}
                </Text>
              </View>

              <View style={excessKbpsStyles.whitespaceTableCol}>
                <Text style={excessKbpsStyles.tableCell}></Text>
              </View>
            </View>

            {
              // eslint-disable-next-line
              device.ports.map(port => {
                // eslint-disable-next-line
                if (port.hasExcessKbps) {
                  return (
                    <View style={excessKbpsStyles.tableRow} key={port.name} wrap={false}>

                      <View style={excessKbpsStyles.portNameTableCol}>
                        <Text style={excessKbpsStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(port.name, false)}</Text>
                      </View>

                      {this.getMAUTypeCell(port.MAUType)}
                      {this.getLineDelayValueCell(port.lineDelayValue)}
                      {this.getSpeedCell(port.speed)}
                      {this.createKbpsTableCell(port.inputKbps)}
                      {this.createKbpsTableCell(port.exitKbps)}
                      {this.getLinkStateLinkCell(port.linkStateLink)}

                      <View style={excessKbpsStyles.solvedTableCol}>
                        <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
                      </View>

                    </View>
                  );
                }
              })
            }
          </View >
        );

      })
    );
  }

  createKbpsTableCell = (kbps) => {
    if (kbps > 50000) {
      return (
        <View style={excessKbpsStyles.errorTableCol}>
          <Text style={deltaErrorsStyles.tableCell}>
            {this.parseFloatTo2DecimalPlaces(kbps).toString().replace(".", ",")}
          </Text>
        </View>
      );
    }
    else {
      return (
        <View style={excessKbpsStyles.tableCol}>
          <Text style={deltaErrorsStyles.tableCell}>
            {this.parseFloatTo2DecimalPlaces(kbps).toString().replace(".", ",")}
          </Text>
        </View>
      );
    }
  }

  // ----------------- INACTIVE PORT -----------------
  createInactivePortPages = () => {
    if (this.props.inactivePort.length > 0) {

      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={inactivePortStyles.page}>

          {this.getPageHeader()}
          <Text style={inactivePortStyles.pageTitle} fixed>{inactivePortPageIndex}{Strings.INACTIVE_PORT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.INACTIVE_PORT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.INACTIVE_PORT_SUGGESTION_2}</Text>


          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={inactivePortStyles.table}>
            {this.createInactivePortTableHeader()}
            {this.createInactivePortTable()}
          </View>

          {this.getPageFooter("inactivePort")}

        </Page>
      );
    }
  }

  createInactivePortTableHeader = () => {
    return (
      <View style={inactivePortStyles.tableRow} fixed>

        <View style={inactivePortStyles.horaryTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={inactivePortStyles.ipTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={inactivePortStyles.macTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={inactivePortStyles.productNameTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={inactivePortStyles.interfaceLabelTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={inactivePortStyles.linkStatusTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.STATUS}</Text>
        </View>

        <View style={inactivePortStyles.solvedTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createInactivePortTable = () => {
    return (
      this.props.inactivePort.map(problem => {
        return (
          <View style={inactivePortStyles.tableRow} key={problem._id} wrap={false}>

            <View style={inactivePortStyles.horaryTableCol}>
              <Text style={inactivePortStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={inactivePortStyles.ipTableCol}>
              <Text style={inactivePortStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={inactivePortStyles.macTableCol}>
              <Text style={inactivePortStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={inactivePortStyles.productNameTableCol}>
              <Text style={inactivePortStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.name, false)}</Text>
            </View>

            <View style={inactivePortStyles.interfaceLabelTableCol}>
              <Text style={inactivePortStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.portName, false)}</Text>
            </View>

            <View style={inactivePortStyles.linkStatusTableCol}>
              <Text style={inactivePortStyles.tableCell}>{this.getLinkStatus(problem.linkStateLink)}</Text>
            </View>

            <View style={inactivePortStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  getLinkStatus = (link_status) => {
    if (link_status === "up") {
      return Strings.ACTIVE;
    }
    else if (link_status === "down") {
      return Strings.INACTIVE;
    }
    else {
      return Strings.NO_ANSWER;
    }
  }

  // ----------------- FIRMWARE INCOHERENCE -----------------
  createFirmwareIncoherencePages = () => {
    if (this.props.firmwareIncoherence.length > 0) {
      return (
        <Page
          size="A4"
          orientation="landscape"
          wrap={true}
          style={firmwareIncoherenceStyles.page}>

          {this.getPageHeader()}
          <Text style={firmwareIncoherenceStyles.pageTitle} fixed>{firmwareIncoherencePageIndex}{Strings.HW_FW_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.HW_FW_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.HW_FW_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.HW_FW_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={firmwareIncoherenceStyles.table}>
            {this.createFirmwareIncoherenceTableHeader()}
            {this.createFirmwareIncoherenceTable()}
          </View>

          {this.getPageFooter("firmwareIncoherence")}

        </Page>
      );
    }
  }

  createFirmwareIncoherenceTableHeader = () => {
    return (
      <View style={firmwareIncoherenceStyles.tableRow} fixed>

        <View style={firmwareIncoherenceStyles.horaryTableColHeader}>
          <Text style={firmwareIncoherenceStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={firmwareIncoherenceStyles.vHWvFWipTableColHeader}>
          <Text style={firmwareIncoherenceStyles.tableCellHeader}>Hardware{"\n"}{Strings.VERSION_OF}</Text>
        </View>

        <View style={firmwareIncoherenceStyles.manMacNameTableColHeader}>
          <Text style={firmwareIncoherenceStyles.tableCellHeader}>{Strings.MODEL}</Text>
        </View>

        <View style={firmwareIncoherenceStyles.vHWvFWipTableColHeader}>
          <Text style={firmwareIncoherenceStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={firmwareIncoherenceStyles.manMacNameTableColHeader}>
          <Text style={firmwareIncoherenceStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={firmwareIncoherenceStyles.manMacNameTableColHeader}>
          <Text style={firmwareIncoherenceStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={firmwareIncoherenceStyles.vHWvFWipTableColHeader}>
          <Text style={firmwareIncoherenceStyles.tableCellHeader}>Firmware{"\n"}{Strings.VERSION_OF}</Text>
        </View>

        <View style={firmwareIncoherenceStyles.solvedTableColHeader}>
          <Text style={firmwareIncoherenceStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createFirmwareIncoherenceTable = () => {
    return (
      this.props.firmwareIncoherence.map(problem => {
        let infos = this.getHwFwInfos(problem);

        return (
          <View key={problem._id}>

            <View style={firmwareIncoherenceStyles.tableRow} wrap={false}>

              <View style={firmwareIncoherenceStyles.horaryTableCol}>
                <Text style={firmwareIncoherenceStyles.tableCell}>{this.formatTime(problem)}</Text>
              </View>

              <View style={firmwareIncoherenceStyles.vHWvFWipTableCol}>
                <Text style={firmwareIncoherenceStyles.tableCell}>{problem.hardwareVersion}</Text>
              </View>

              <View style={firmwareIncoherenceStyles.manMacNameTableCol}>
                <Text style={firmwareIncoherenceStyles.tableCell}>
                  {UtilsInstance.addWhitespaceToLongStrings(problem.model, false)}
                </Text>
              </View>

              <View style={firmwareIncoherenceStyles.whitespaceTableCol}></View>

            </View>

            {
              infos.map(info => {
                return (
                  <View style={firmwareIncoherenceStyles.tableRow} key={info.mac} wrap={false}>

                    <View style={firmwareIncoherenceStyles.whitespace2TableCol}></View>

                    <View style={firmwareIncoherenceStyles.vHWvFWipTableCol}>
                      <Text style={firmwareIncoherenceStyles.tableCell}>{info.ip}</Text>
                    </View>

                    <View style={firmwareIncoherenceStyles.manMacNameTableCol}>
                      <Text style={firmwareIncoherenceStyles.tableCell}>{UtilsInstance.treatUppercase(info.mac)}</Text>
                    </View>

                    <View style={firmwareIncoherenceStyles.manMacNameTableCol}>
                      <Text style={firmwareIncoherenceStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(info.name, false)}</Text>
                    </View>

                    <View style={firmwareIncoherenceStyles.vHWvFWipTableCol}>
                      <Text style={firmwareIncoherenceStyles.tableCell}>{info.firmware}</Text>
                    </View>

                    <View style={firmwareIncoherenceStyles.solvedTableCol}>
                      <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
                    </View>

                  </View>
                );
              })
            }
          </View>
        );
      })
    );
  }

  getHwFwInfos = (problem) => {
    let infos = [];

    for (let i = 0; i < problem.names.length; i++) {
      infos.push({
        name: problem.names[i],
        ip: problem.ips[i],
        mac: problem.macs[i],
        firmware: problem.firmwares[i],
      });
    }

    return infos;
  }

  // ----------------- MODULE INCOHERENCE -----------------
  createModuleIncoherencePages = () => {
    if (this.props.moduleIncoherence.length > 0) {
      return (
        <Page
          size="A4"
          orientation="landscape"
          wrap={true}
          style={moduleIncoherenceStyles.page}>

          {this.getPageHeader()}
          <Text style={moduleIncoherenceStyles.pageTitle} fixed>{moduleIncoherencePageIndex}{Strings.MODULE_INCOHERENCE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.MODULE_INCOHERENCE_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.MODULE_INCOHERENCE_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={moduleIncoherenceStyles.table}>
            {this.createModuleIncoherenceTableHeader()}
            {this.createModuleIncoherenceTable()}
          </View>

          {this.getPageFooter("moduleIncoherence")}

        </Page>
      );
    }
  }

  createModuleIncoherenceTableHeader = () => {
    return (
      <View style={moduleIncoherenceStyles.tableRow} fixed>

        <View style={moduleIncoherenceStyles.horaryTableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={moduleIncoherenceStyles.ipTableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={moduleIncoherenceStyles.macTableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={moduleIncoherenceStyles.moduleTableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>{Strings.MODULE}</Text>
        </View>

        <View style={moduleIncoherenceStyles.tableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>Ident{"\n"}Number</Text>
        </View>

        <View style={moduleIncoherenceStyles.infoTextTableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>Info{"\n"}Text</Text>
        </View>

        <View style={moduleIncoherenceStyles.moduleOrderTableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>Module{"\n"}Name</Text>
        </View>

        <View style={moduleIncoherenceStyles.moduleOrderTableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>Order{"\n"}Number</Text>
        </View>

        <View style={moduleIncoherenceStyles.solvedTableColHeader}>
          <Text style={moduleIncoherenceStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createModuleIncoherenceTable = () => {
    return (
      this.props.moduleIncoherence.map(problem => {
        return (
          <View wrap={false} key={problem._id}>

            <View style={moduleIncoherenceStyles.tableRow} wrap={false}>

              <View style={moduleIncoherenceStyles.horaryTableCol}>
                <Text style={moduleIncoherenceStyles.tableCell}>{this.formatTime(problem)}</Text>
              </View>

              <View style={moduleIncoherenceStyles.ipTableCol}>
                <Text style={moduleIncoherenceStyles.tableCell}>{problem.ip}</Text>
              </View>

              <View style={moduleIncoherenceStyles.macTableCol}>
                <Text style={moduleIncoherenceStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
              </View>

              <View style={moduleIncoherenceStyles.moduleTableCol}>
                <Text style={moduleIncoherenceStyles.tableCell}>{problem.module}</Text>
              </View>

              <View style={moduleIncoherenceStyles.whitespaceTableCol}></View>

            </View>

            {
              this.getModuleInfos(problem).map(info => {
                return (
                  <View style={moduleIncoherenceStyles.tableRow} key={info.identNumber} wrap={false}>

                    <View style={moduleIncoherenceStyles.whitespace2TableCol}>
                      <Text style={moduleIncoherenceStyles.tableCell}>{info.infoType}</Text>
                    </View>

                    <View style={moduleIncoherenceStyles.tableCol}>
                      <Text style={moduleIncoherenceStyles.tableCell}>{info.identNumber}</Text>
                    </View>

                    <View style={moduleIncoherenceStyles.infoTextTableCol}>
                      <Text style={moduleIncoherenceStyles.tableCell}>
                        {UtilsInstance.addWhitespaceToLongStrings(info.infoText)}
                      </Text>
                    </View>

                    <View style={moduleIncoherenceStyles.moduleOrderTableCol}>
                      <Text style={moduleIncoherenceStyles.tableCell}>
                        {UtilsInstance.addWhitespaceToLongStrings(info.moduleName)}
                      </Text>
                    </View>

                    <View style={moduleIncoherenceStyles.moduleOrderTableCol}>
                      <Text style={moduleIncoherenceStyles.tableCell}>{info.orderNumber}</Text>
                    </View>

                    <View style={moduleIncoherenceStyles.solvedTableCol}>
                      <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
                    </View>

                  </View>
                );
              })
            }
          </View>
        );
      })
    );
  }

  getModuleInfos = (problem) => {
    let infos = [];

    for (let i = 0; i < problem.identNumbers.length; i++) {
      let info = {
        identNumber: problem.identNumbers[i],
        infoText: problem.infoTexts[i],
        moduleName: problem.moduleNames[i],
        orderNumber: problem.orderNumbers[i],
      };

      if (i === 0) {
        info.infoType = Strings.RECEIVED_INFO;
      }
      else {
        info.infoType = Strings.EXPECTED_INFO;
      }

      infos.push(info);
    }

    return infos;
  }

  // ----------------- DUPLEX MISMATCH -----------------
  createDuplexMismatchPages = () => {
    if (this.props.duplexMismatch.length > 0) {
      return (
        <Page
          size="A4"
          orientation="landscape"
          wrap={true}
          style={duplexMismatchStyles.page}>

          {this.getPageHeader()}
          <Text style={duplexMismatchStyles.pageTitle} fixed>{duplexMismatchPageIndex}{Strings.DUPLEX_MISMATCH_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DUPLEX_MISMATCH_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>• {Strings.DUPLEX_MISMATCH_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.DUPLEX_MISMATCH_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.DUPLEX_MISMATCH_SUGGESTION_4}</Text>


          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={duplexMismatchStyles.table}>
            {this.createDuplexMismatchTableHeader()}
            {this.createDuplexMismatchTable()}
          </View>

          {this.getPageFooter("duplexMismatch")}

        </Page>
      );
    }
  }

  createDuplexMismatchTableHeader = () => {
    return (
      <View style={duplexMismatchStyles.tableRow} fixed>

        <View style={duplexMismatchStyles.horaryTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={duplexMismatchStyles.ipTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.IP} 1</Text>
        </View>

        <View style={duplexMismatchStyles.nameTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.NAME} 1</Text>
        </View>

        <View style={duplexMismatchStyles.portTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.PORT} 1</Text>
        </View>

        <View style={duplexMismatchStyles.duplexModeTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.DUPLEX_MODE} 1</Text>
        </View>

        <View style={duplexMismatchStyles.ipTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.IP} 2</Text>
        </View>

        <View style={duplexMismatchStyles.nameTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.NAME} 2</Text>
        </View>

        <View style={duplexMismatchStyles.portTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.PORT} 2</Text>
        </View>

        <View style={duplexMismatchStyles.duplexModeTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.DUPLEX_MODE} 2</Text>
        </View>

        <View style={duplexMismatchStyles.solvedTableColHeader}>
          <Text style={duplexMismatchStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDuplexMismatchTable = () => {
    return (
      this.props.duplexMismatch.map(problem => {
        return (
          <View style={duplexMismatchStyles.tableRow} key={problem._id} wrap={false}>

            <View style={duplexMismatchStyles.horaryTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={duplexMismatchStyles.ipTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{problem.ips[0]}</Text>
            </View>

            <View style={duplexMismatchStyles.nameTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.names[0])}</Text>
            </View>

            <View style={duplexMismatchStyles.portTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.portNames[0])}</Text>
            </View>

            <View style={duplexMismatchStyles.duplexModeTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{problem.MAUTypes[0]}</Text>
            </View>

            <View style={duplexMismatchStyles.ipTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{problem.ips[1]}</Text>
            </View>

            <View style={duplexMismatchStyles.nameTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.names[1])}</Text>
            </View>

            <View style={duplexMismatchStyles.portTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.portNames[1])}</Text>
            </View>

            <View style={duplexMismatchStyles.duplexModeTableCol}>
              <Text style={duplexMismatchStyles.tableCell}>{problem.MAUTypes[1]}</Text>
            </View>

            <View style={duplexMismatchStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- DELAY EXCEEDED -----------------
  createDelayExceededPages = () => {
    if (this.props.lineDelayExceededLimit.length > 0) {

      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={delayExceededStyles.page}>

          {this.getPageHeader()}
          <Text style={delayExceededStyles.pageTitle} fixed>{delayExceededPageIndex}{Strings.DELAY_EXCEEDED_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DELAY_EXCEEDED_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DELAY_EXCEEDED_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.DELAY_EXCEEDED_SUGGESTION_3}</Text>


          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={delayExceededStyles.table}>
            {this.createDelayExceededTableHeader()}
            {this.createDelayExceededTable()}
          </View>

          {this.getPageFooter("lineDelayExceededLimit")}

        </Page>
      );
    }
  }

  createDelayExceededTableHeader = () => {
    return (
      <View style={delayExceededStyles.tableRow} fixed>

        <View style={delayExceededStyles.horaryTableColHeader}>
          <Text style={delayExceededStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={delayExceededStyles.ipTableColHeader}>
          <Text style={delayExceededStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={delayExceededStyles.macTableColHeader}>
          <Text style={delayExceededStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={delayExceededStyles.productNameTableColHeader}>
          <Text style={delayExceededStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={delayExceededStyles.portNameTableColHeader}>
          <Text style={delayExceededStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={delayExceededStyles.delayTableColHeader}>
          <Text style={delayExceededStyles.tableCellHeader}>{Strings.LINE_DELAY_VALUE_1}</Text>
        </View>

        <View style={delayExceededStyles.solvedTableColHeader}>
          <Text style={delayExceededStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDelayExceededTable = () => {
    return (
      this.props.lineDelayExceededLimit.map(problem => {
        return (
          <View style={delayExceededStyles.tableRow} key={problem._id} wrap={false}>

            <View style={delayExceededStyles.horaryTableCol}>
              <Text style={delayExceededStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={delayExceededStyles.ipTableCol}>
              <Text style={delayExceededStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={delayExceededStyles.macTableCol}>
              <Text style={delayExceededStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={delayExceededStyles.productNameTableCol}>
              <Text style={delayExceededStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.product_name, false)}</Text>
            </View>

            <View style={delayExceededStyles.portNameTableCol}>
              <Text style={delayExceededStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.portName, false)}</Text>
            </View>

            <View style={delayExceededStyles.delayTableCol}>
              <Text style={delayExceededStyles.tableCell}>{problem.lineDelay} ns</Text>
            </View>

            <View style={delayExceededStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- FAULTS -----------------
  createIntermittentFailurePages = () => {
    if (this.props.intermittentFailure.length > 0) {

      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={alarmStyles.page}>

          {this.getPageHeader()}

          <Text style={alarmStyles.pageTitle} fixed>{intermittentFailurePageIndex}{Strings.INTERMITTENT_FAILURE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.INTERMITTENT_FAILURES_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>• {Strings.INTERMITTENT_FAILURES_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.INTERMITTENT_FAILURES_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.INTERMITTENT_FAILURES_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={alarmStyles.table}>
            {this.createIntermittentFailureTableHeader()}
            {this.createIntermittentFailureTable()}
          </View>

          {this.getPageFooter("intermittentFailure")}

        </Page>
      );
    }
  }

  createIntermittentFailureTableHeader = () => {
    return (
      <View style={alarmStyles.tableRow} fixed>

        <View style={alarmStyles.horaryTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={alarmStyles.ipTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={alarmStyles.macTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={alarmStyles.productNameTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={alarmStyles.pingTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.FAULTS}</Text>
        </View>

        <View style={alarmStyles.solvedTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createIntermittentFailureTable = () => {
    return (
      this.props.intermittentFailure.map(problem => {
        return (
          <View style={alarmStyles.tableRow} key={problem._id} wrap={false}>

            <View style={alarmStyles.horaryTableCol}>
              <Text style={alarmStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={alarmStyles.ipTableCol}>
              <Text style={alarmStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={alarmStyles.macTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={alarmStyles.productNameTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.product_name, false)}</Text>
            </View>

            <View style={alarmStyles.pingNameTableCol}>
              <Text style={alarmStyles.tableCell}>{problem.failures}</Text>
            </View>

            <View style={alarmStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- LOST IP -----------------
  createLostIpPages = () => {
    if (this.props.lostIp.length > 0) {

      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={lostIpStyles.page}>

          {this.getPageHeader()}

          <Text style={lostIpStyles.pageTitle} fixed>{lostIpPageIndex}{Strings.LOST_IP_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.LOST_IP_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>• {Strings.LOST_IP_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={lostIpStyles.table}>
            {this.createLostIpTableHeader()}
            {this.createLostIpTable()}
          </View>

          {this.getPageFooter("lostIp")}

        </Page>
      );
    }
  }

  createLostIpTableHeader = () => {
    return (
      <View style={lostIpStyles.tableRow} fixed>

        <View style={lostIpStyles.horaryTableColHeader}>
          <Text style={lostIpStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={lostIpStyles.ipTableColHeader}>
          <Text style={lostIpStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={lostIpStyles.macTableColHeader}>
          <Text style={lostIpStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={lostIpStyles.productNameTableColHeader}>
          <Text style={lostIpStyles.tableCellHeader}>{Strings.MODEL}</Text>
        </View>

        <View style={lostIpStyles.solvedTableColHeader}>
          <Text style={lostIpStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createLostIpTable = () => {
    return (
      this.props.lostIp.map(problem => {
        return (
          <View style={lostIpStyles.tableRow} key={problem._id} wrap={false}>

            <View style={lostIpStyles.horaryTableCol}>
              <Text style={lostIpStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={lostIpStyles.ipTableCol}>
              <Text style={lostIpStyles.tableCell}>0.0.0.0</Text>
            </View>

            <View style={lostIpStyles.macTableCol}>
              <Text style={lostIpStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={lostIpStyles.productNameTableCol}>
              <Text style={lostIpStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.model, false)}</Text>
            </View>

            <View style={lostIpStyles.checkedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "23vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    this.resetSummaryIndexes();
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  centeredSubHeaderText: {
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center",
  },

  centeredSecondSubHeaderText: {
    marginTop: "3vh",
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginTop: "1vh",
    marginBottom: 4,
    fontFamily: "RobotoMedium"
  },

  normalSpacedText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  checkBox: {
    width: 12,
    height: 12,
  },

  mainTitleUpperLine: {
    marginTop: "2vh",
    marginBottom: "2vh",
    marginLeft: "180px",
    height: "1px",
    width: "156px",
    backgroundColor: "black",
  },

  mainTitle: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitle2: {
    marginTop: "1vh",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitleBottomLine: {
    marginTop: "2vh",
    marginLeft: "206px",
    height: "1px",
    width: "100px",
    backgroundColor: "black",
  },

  noErrors: {
    //marginTop: "28vh",
    textAlign: "center",
    fontSize: 12,
    //marginBottom: "4vh",
    //fontWeight: "bold",
    fontFamily: "RobotoRegular"
  },

});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const alarmStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  pingTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  pingNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const duplicateIPStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipMacNameTableColHeader: {
    width: "35%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  checkedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipMacNameTableCol: {
    width: "35%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  checkedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const duplicateNameStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  nameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  ipMacTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  checkedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  nameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  ipMacTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  checkedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const avgPingExceededStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  pingTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  pingNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const deltaErrorsStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  ipTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  ipTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  whitespaceTableCol: {
    width: "70%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  portNameTableCol: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  },

  activeTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime",
  },

  unknownTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#dcdcdc",
  },

  errorTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ff6600"
  },
});

const portNotInFullDuplexStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceLabelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  duplexModeTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceLabelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  duplexModeTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const excessKbpsStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  ipTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  ipTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  whitespaceTableCol: {
    width: "70%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  portNameTableCol: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  },

  activeTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime",
  },

  unknownTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#dcdcdc",
  },

  errorTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ff6600"
  },
});

const inactivePortStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceLabelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  linkStatusTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceLabelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  linkStatusTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const firmwareIncoherenceStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  vHWvFWipTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  manMacNameTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  vHWvFWipTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  manMacNameTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  },

  whitespaceTableCol: {
    width: "60%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  whitespace2TableCol: {
    width: "40%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

});

const moduleIncoherenceStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  moduleTableColHeader: {
    width: "6%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "9%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  infoTextTableColHeader: {
    width: "17%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  moduleOrderTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  moduleTableCol: {
    width: "6%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  infoTextTableCol: {
    width: "17%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  moduleOrderTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCol: {
    width: "9%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  },

  whitespaceTableCol: {
    width: "57%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  whitespace2TableCol: {
    width: "43%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

});

const duplexMismatchStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  nameTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  portTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  duplexModeTableColHeader: {
    width: "9%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "6%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  nameTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  portTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  duplexModeTableCol: {
    width: "9%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "6%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const delayExceededStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  portNameTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  delayTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  portNameTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  delayTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const lostIpStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  checkedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

export default TsExpertReport;
